<template>
    <div>
        <app-header></app-header>

        <!-- big screen swtiching with the notes button, is it weird? should I use a buefy thing? -->

        <!-- publish and user querys -->
        <query-tag/>
        
        <div id="project-title" class="section">

            <h1 class="title is-capitalized has-text-centered">
                <router-link :to="{ name: 'project', params: {project: project } }">
                    {{ project }}
                </router-link>

                <!-- edit button -->
                <!-- is_user_admin comes from mixin -->
                <a v-if="is_user_admin && project_details.length!=0"
                    class="button is-primary is-light"
                    outlined
                    
                    :href="'/admin/dencore/project/' + project_details[0].id + /change/"
                >
                    <b-icon
                        icon="pencil"
                        size="is-small">
                    </b-icon>
                </a>

                <span v-if="shot">
                    /
                </span>
                
                <router-link v-if="shot" :to="{ name: 'shot', params: {project: project, shot: ThisShot.name } }">
                    Shot {{shot}}
                </router-link>

                <!-- button that toggles the main display to notes -->
                <div
                    v-on:click="ToggleNotesView()"
                    class="button is-primary is-pulled-right"
                >
                    <b-icon
                        icon="pen"
                        size="is-small">
                    </b-icon>
                    <span>
                        <span v-if=notes_view>
                            Hide Notes
                        </span>
                        <span v-else>
                            Notes
                        </span>
                        <b-tag
                            v-if="NoteCount"
                            class="count-tag"
                            rounded
                        >
                            {{NoteCount}}
                        </b-tag>
                    </span>
                </div>
   
            </h1>

            <!-- warnings for missing projects/shots on database -->
            <b-notification v-if="is_user_admin && !project_exists"
                type="is-warning"
                has-icon
                aria-close-label="Close notification">
                <p>Project "{{project}}" doesn't exist on database</p>
                <a
                    class="button is-primary"
                    :href="'/admin/dencore/project/add/?name=' + project"
                >
                    Create
                </a>
            </b-notification>

            <b-notification v-if="is_user_admin && !shot_exists"
                type="is-warning"
                has-icon
                aria-close-label="Close notification">
                <p>Shot "{{shot}}" doesn't exist on database</p>
                
                <a
                    class="button is-primary"
                    :href="'/admin/dencore/shot/add/?name=' + shot + '&project=' + project_details[0].id"
                >
                    Create
                </a>
            </b-notification>
            

        </div>

        <!-- Hidden if no details exist -->
        <!-- Hidden when in notes_view -->
        <project-details
            v-if="project_details.length && !notes_view"
            class="is-hidden-mobile"
            :sortable=false
            :project=this.project
        ></project-details>

        <!-- shot buttons -->
        <!-- hidden when in notes_view -->
        <div id="shot_buttons" class="section buttons"
            v-if="!projects_loading && !notes_view">
            
            <!-- instead of shot_set, use the computed FilteredShots -->
            <div class="button is-primary is-large"
                v-for="shot_child in FilteredShots"
                v-bind:key="shot_child.id"
            >                
                <router-link :to="{ name: 'shot', params: {project: project, shot: shot_child.name} }">
                    {{ shot_child.name }}
                </router-link>
            </div>

        </div>

        <div v-if="NoResults" class="section">
            <h1 class="title has-text-centered">
                No posts Found.
            </h1>
        </div>

        <div v-if="NonePublished" class="section">
            <h1 class="title has-text-centered">
                try unflagged?
                <b-switch v-model="published" @input="PublishedToggle">
                    <b-icon icon="flag" size="is-small" type="is-primary"></b-icon>
                </b-switch>
            </h1>
        </div>

        <!-- hidden when in notes_view -->
        <rev-card-container
            v-if="!notes_view"
            :reviewables="reviewables">
        </rev-card-container>

        <!-- notes -->
        <note-card-container
            v-if="notes_view"
            :notes="TheseNotes">
        </note-card-container>

    </div>
</template>

<script>
    import axios from 'axios'
    import { InfiniteScroll } from '../mixins/ui'
    import { ReviewableQuerys } from '../mixins/querys'
    import { GetReviewables } from '../mixins/reviewables'
    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'
    
    // to reference flagged switch
    import { eventBusPublished } from '../main';
    
    // for is_user_admin
    import { GetUserAdmin } from '../mixins/users'

    export default {
        mixins: [InfiniteScroll, ReviewableQuerys, GetReviewables, GetAxiosAuthConfig, GetUserAdmin],
        data() {
            return {
                // Set data property from the router (routes.js)
                project: this.$route.params.project,
                shot: this.$route.params.shot,

                // Data properties for the den api
                reviewables_loading: true,
                reviewables: [],
                projects_loading: true,
                project_details: [],
                project_exists: true,
                shot_exists: true,

                // seperate because it needs sorting
                shot_set : [],
                notes_view: false,

                // published view switch init
                published: eventBusPublished.only_published,
            }
        },
        // watch to see if router has changed, update id
        watch: {
            '$route'(to, from) {
                this.project = to.params.project
                this.shot = to.params.shot
                this.GetReviewables()
                this.GetProjectDetails()
            },
        },
        computed: {
            FilteredShots() {
                // Filters shots based on their status
                return this.shot_set.filter(function(u) {
                    return u.status
                })
            },
            ThisShot() {
                // get this shots details from the router/shotset
                // and set this.shot_exists

                // console.log('this.shot', this.shot)
                // console.log('this.shot_set', this.shot_set)

                let found_shot = this.shot_set.filter(shot => shot.name == this.shot)
                if (found_shot.length > 0) {
                    this.shot_exists = true
                    return found_shot[0]
                }
                else {
                    this.shot_exists = false
                    return this.shot
                }
            },
            NoteCount() {
                // build array of note objects from all avaliable shots
                let notes = []

                // loop through shots in project
                for (let i in this.shot_set) {

                    let shot_object = this.shot_set[i]
                    
                    // if 'this.shot' is defined then 'filter' the notes
                    if (this.shot != undefined) {
                        if (this.shot != shot_object.name) {
                            continue
                        }
                    }

                    // get the note_set of the shot
                    let note_set = shot_object.note_set

                    // loop thorough notes in a shot and add them to an array
                    for (let i_n in note_set) {
                        notes.push(note_set[i_n])
                    }
                }
                
            
                // Filter js method
                let filtered = notes.filter(function(note) {
                    return note.status < 2;
                })
                return filtered.length


                // Filter js method
                // let filtered = this.notes.filter(function(note) {
                //     return note.status < 2;
                // })
                // return filtered.length
            },
            TheseNotes() {
                // build array of note objects from all avaliable shots
                let notes = []

                // loop through shots in project
                for (let i in this.shot_set) {

                    let shot_object = this.shot_set[i]
                    
                    // if 'this.shot' is defined then 'filter' the notes
                    if (this.shot != undefined) {
                        if (this.shot != shot_object.name) {
                            continue
                        }
                    }

                    // get the note_set of the shot
                    let note_set = shot_object.note_set

                    // loop thorough notes in a shot and add them to an array
                    for (let i_n in note_set) {
                        notes.push(note_set[i_n])
                    }
                }
                
                return notes
            }
        },
        methods: {
            PublishedToggle(value) {
                // this is a repeated function from the header view
                eventBusPublished.TogglePublishedOnly()
            },
            ToggleNotesView() {
                this.notes_view = !this.notes_view
            },
            GetProjectDetails() {
                // using the global variables, create the rest url to get
                // REST url has a default limit can give it
                let resturl = window.location.origin + '/api/projects/?format=json' + '&name=' + this.project

                axios.get(resturl, axios_auth_config)
                    .then(response => {
                        // catch if no project found
                        if (response.data.results.length ==0 ) {
                            console.info('No project named \"' + this.project + '\" found on DB')
                            this.project_exists = false
                            this.projects_loading = false
                            return
                        }

                        this.project_details = response.data.results

                        // get the shot set because it needs to be sorted
                        let shot_set = response.data.results[0].shot_set

                        // sort by the key 'name'
                        this.shot_set = shot_set.sort((a, b) => a.name.localeCompare(b.name));

                        // now that it has finished loading
                        this.projects_loading = false
                    })
                    .catch(error => console.log(error))
            },
            sortByKey(array, key) {
                //generic function
                return array.sort(function(a, b) {
                    let x = a[key]
                    let y = b[key]
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0))
                })
            },
        },
        mounted() {
            this.GetProjectDetails()
            this.GetReviewables()

            eventBusPublished.$on('publish_toggled', (data) => {
                this.published = data
            })

        },
    }
</script>

<style scoped lang="scss">
    @import "../styles/_variables.scss";

    // override all
    .section {
        padding: 1rem 1rem 0 1rem;
    }
    .buttons:not(:last-child) {
        margin-bottom: 0rem;
    }

    // nest elements under parent in sass
    #project-title {
        // padding: 1rem 1rem 0 1rem;
        .title, a {
            color: $den_offwhite;
        }
    }
    
    #project-title a:hover {
        text-decoration: underline;
    }

    // nest elements under parent in sass
    #shot_buttons {
        .button {
            background-color: $den_bg_lighter;
        }
    }

    #notes_header .panel-heading {
        background-color: $den_offwhite;
    }
    
</style>
